
import React from 'react';
import styled from 'styled-components';
import Layout from '../Layout/Layout';
import {Block} from '../../styles/commons';
import PageHeader from '../PageHeader/PageHeader';
import './PortalFAQScreen.css'


const PortalFAQScreen = props => {
  return (
    <Layout product='portal'>
    <PageHeader title='FAQ'/>
      <Block>
      <Question>
        Is my data secure?
      </Question>
      <Answer>
      DreamEx Connect stores all collected data in an encrypted format in a secure environment utilizing Amazon Web Services.
      </Answer>

      <Question>
        Do DreamEx share the information we collect?
      </Question>
      <Answer>
      DreamEx does not provide any collected information with parties external to our organization.
      </Answer>

      <Question>
        Does DreamEx charge a fee if a Company and a Source of Funds (SOF) make a deal?
      </Question>
      <Answer>
      DreamEx Connect does not charge a fee if a Company and a SOF makes an investment deal. DreamEx Connect is software
      as a service and is not operating in anyway as a broker between a Company and an SOF. 
      </Answer>

      <Question>
        How do I know if my Company Profile is complete?
      </Question>
      <Answer>
      Answer Company Profile is considered complete if a Company has completed their profile in the Compose Page,
      uploaded supplemental files in the Upload Files page and specified the parameters of their deal in the Specify Criteria page.  
      </Answer>

      <Question>
        Can DreamEx assist me in creating my Company Profile?
      </Question>
      <Answer>
      Yes. Dream Exchange provides a service called a Strat Plan that will assist Companies in in the development of a
      comprehensive set of materials to create a compelling Company profile. Answer Strat Plan assists organizations in the
      development of the data and materials needed to negotiate a fair and reasonable deal faster and according to the
      terms most important to you. In the end, organizations that use the information from their Strat Plan will be more
      effective in controlling the negotiations with a third-party advisor and potential sources of funds.
      Click <a href='https://dreamex-7126572.hs-sites.com/prepare-for-your-small-business-capital-raise' target='_blank' rel='noreferrer'>here</a> if you are interested in learning more.
      </Answer>

      <Question>
        Why are offering documents prohibited from my profile? 
      </Question>
      <Answer>
      DreamEx Connect is not a brokerage site and is not facilitating the sale of securities.
      Rather, it is a software as a service, similar to Facebook and LinkedIn, to connect great
      companies with sources of funds looking to invest. Once the connection is made, companies and
      sources of funds will conduct the important activities of due diligence, deal structuring and
      negotiations, legal review, etc. outside of DreamEx Connect. 
      </Answer>

      <Question>
        Can I make changes to my Company profile once it is published? 
      </Question>
      <Answer>
      Yes. All Company profiles are reviewed by DreamEx staff prior to posting on the DreamEx
      Connect to ensure that the profile meets the posting standards of the site.
      </Answer>

      <Question>
        Are Companies limited in the number of uploaded files? 
      </Question>
      <Answer>
      There are no limits in the number of files a company can include with their profile.
      </Answer>

      <Question>
        Can a Source of Funds limit unsolicited messages from Companies?
      </Question>
      <Answer>
      Yes. Answer Source of Funds (SOF) can elect to not receive unsolicited messages from Companies. In this situation, an SOF
      would deselect the “Allow Companies to Contact Me” checkbox in the Interests page.
      </Answer>
    </Block>
  </Layout>
  )
}

const Question = styled.p`
  font-weight: bolder
`;

const Answer = styled.p`
  margin-top: 0px;
`;

export default PortalFAQScreen
